import React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import {Loading as WellnessCreditsVolumeLoading} from '/component/partial/reportCard/ExpiringWellnessCreditsReportContent/ExpiringWellnessCreditsVolume/Loading';
import {REPORT_CARD_EXPIRING_WELLNESS} from '/enum/reportCard.enum';
import {useTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import {styles} from './Loading.style';
interface LoadingProps {
  contentName: string;
}

export const Loading: React.FC<LoadingProps> = ({contentName = ''}) => {
  const {tt} = useTranslation('reportCardContent.newCoachesReportContent');
  const featureFlag = useSelector(variablesFeatureFlag);
  const updatePremierPlus = shouldReleaseFeature(
    get(featureFlag, 'ff_Premier_Plus', ''),
  );

  return (
    <View style={styles.footer}>
      {contentName === REPORT_CARD_EXPIRING_WELLNESS && (
        <WellnessCreditsVolumeLoading />
      )}
      <View style={styles.footerRow}>
        {updatePremierPlus ? (
          <Text variant="button">
            {tt('footer.premier.label', 'Premier+ Member')}
          </Text>
        ) : (
          <Text variant="button">
            {tt('footer.premier.label', 'Premier Member')}
          </Text>
        )}
        <LoadingBox style={styles.footerBoxPremierMember} />
      </View>
      <View style={styles.footerRow}>
        <Text variant="button">{tt('footer.coach.label', 'Coach')}</Text>
        <LoadingBox style={styles.footerBoxCoach} />
      </View>
      <View style={styles.footerRow}>
        <Text variant="button">{tt('footer.pqv.label', 'PQV')}</Text>
        <LoadingBox style={styles.footerBoxPQV} />
      </View>
      <View style={styles.footerRow}>
        <Text variant="button">
          {tt('footer.lastOrder.label', 'Last Order Date')}
        </Text>
        <LoadingBox style={styles.footerBoxLastOrderDate} />
      </View>
    </View>
  );
};
